module.exports = __webpack_public_path__ + "img/page-jigyo-top-maintenannce.8371f31b.jpg";